// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__y-UDG","footer":"ReportModalFilter_footer__1V1ay"};